import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcVNodes",
  props: {
    /**
     * The vnodes to render
     */
    vnodes: {
      type: [Array, Object],
      default: null
    }
  },
  /**
   * The render function to display the component
   *
   * @return {object} The created VNode
   */
  render() {
    return this.vnodes || this.$slots?.default || this.$scopedSlots?.default?.();
  }
};
const _sfc_render = null;
const _sfc_staticRenderFns = null;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const NcVNodes = __component__.exports;
export {
  NcVNodes as default
};
//# sourceMappingURL=NcVNodes.mjs.map
